export function navigateTo(event, url) {
	event.preventDefault();
	window.location = url;
}


// WEBPACK FOOTER //
// ./src/utils/Navigation.js